import { render } from "./ArticleGenerator.vue?vue&type=template&id=7233921f"
import script from "./ArticleGenerator.vue?vue&type=script&lang=js"
export * from "./ArticleGenerator.vue?vue&type=script&lang=js"

import "./ArticleGenerator.vue?vue&type=style&index=0&id=7233921f&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__